import { handleGetCollection } from '@/constants/db-collection.constants';
import { CreateDynamicApi, GetDynamicApi, UpdateDynamicApi } from '@/services/DynamicApi';
import { setFcmPermissionLoading, setShowNotificationPermissionBanner } from '@/store/firebase-config/firebase-config-slice';
import { initializeApp } from 'firebase/app';
import { deleteToken, getMessaging, getToken, onMessage } from 'firebase/messaging';

const FCM_TOKEN = 'FCM_TOKEN';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

// console.info('*** Firebase Config ***', firebaseConfig, process.env.REACT_APP_FIREBASE_VAPID_KEY);

let firebaseApp;
let messaging;
try {
  firebaseApp = initializeApp(firebaseConfig);
  messaging = getMessaging(firebaseApp);
} catch (error) {
  console.error('Error initializing Firebase:', error);
}

export const onForegroundMessage = (callback) => {
  try {
    const listener = onMessage(messaging, callback);
    return () => {
      listener();
    };
  } catch (error) {
    console.error('Error with foreground message listener:', error);
  }
};

export const getFirebaseToken = async () => {
  try {
    const serviceWorkerRegistration = await getOrRegisterServiceWorker();
    return getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    });
  } catch (error) {
    if (error.code === 'messaging/permission-blocked') {
      return Promise.reject(new Error('Notification permission is blocked.'));
    }
    return Promise.reject(error);
  }
};

export const getOrRegisterServiceWorker = async () => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    try {
      const serviceWorker = await window.navigator.serviceWorker.getRegistration('/firebase-push-notification-scope');
      if (serviceWorker) return serviceWorker;
      return window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/firebase-push-notification-scope',
      });
    } catch (error) {
      console.error('Error during service worker registration:', error);
    }
  } else {
    throw new Error('The browser doesn`t support service worker.');
  }
};

export const removeFirebaseToken = async () => {
  try {
    const serviceWorkerRegistration = await getOrRegisterServiceWorker();
    const currentToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, serviceWorkerRegistration });
    if (currentToken && localStorage.getItem('FCM_TOKEN')) {
      await deleteToken(messaging, currentToken);
    } else {
      console.log('No FCM token found to remove.');
    }
  } catch (error) {
    console.error('Error removing FCM token:', error);
  }
};

export const handleGetFirebaseToken = async (dispatch, userId) => {
  dispatch(setFcmPermissionLoading(true));

  try {
    // Request permission
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {

        try {

          const firebaseToken = await getFirebaseToken();

          localStorage.setItem(FCM_TOKEN, firebaseToken);

          const loggedInUserFcmTokenData = await GetDynamicApi({ collection: handleGetCollection('fcm-token'), filter: { authId: userId } });
          const device = navigator.userAgent;

          if (loggedInUserFcmTokenData.data.data.length <= 0) await CreateDynamicApi({ collection: handleGetCollection('fcm-token'), data: { authId: userId, tokens: [{ device: device, token: firebaseToken }] } });
          else {
            const updatedTokens = [...loggedInUserFcmTokenData.data.data[0].tokens];
            const existingIndex = updatedTokens.findIndex((obj) => obj.device === device);
            if (existingIndex !== -1) updatedTokens[existingIndex].token = firebaseToken;
            else updatedTokens.push({ device: device, token: firebaseToken });
            await UpdateDynamicApi({ collection: handleGetCollection('fcm-token'), filter: { _id: loggedInUserFcmTokenData.data.data[0]._id }, data: { tokens: updatedTokens } });
          }

          if (firebaseToken) dispatch(setShowNotificationPermissionBanner(false));
        } catch (error) {
          if (error.message === 'Notification permission is blocked.') {
            console.log('Permission was denied');
            dispatch(setShowNotificationPermissionBanner(true));
          } else {
            console.error('An error occurred while retrieving the Firebase token. ', error);
          }
        }
      } else if (permission === 'denied') {
        console.log('Permission was denied');
        dispatch(setShowNotificationPermissionBanner(true));
      } else {
        console.log('Permission not granted');
      }
    } else {
      console.log('Notification API not supported');
    }
  } catch (err) {
    console.error('An error occurred while requesting the notification permission. ', err);
  }

  dispatch(setFcmPermissionLoading(false));
};

export const handleRemoveFirebaseToken = async (userId) => {
  removeFirebaseToken();
  localStorage.removeItem(FCM_TOKEN);

  // if (!!userId) {
  //   const device = navigator.userAgent;
  //   const loggedInUserFcmTokenData = await GetDynamicApi({ collection: handleGetCollection('fcm-token'), filter: { authId: userId } });
  //   if (!!loggedInUserFcmTokenData && loggedInUserFcmTokenData.data.data.length > 0) {
  //     const updatedTokens = [...loggedInUserFcmTokenData.data.data[0].tokens].filter((item) => item.device !== device);
  //     try {
  //       await UpdateDynamicApi({ collection: handleGetCollection('fcm-token'), filter: { _id: loggedInUserFcmTokenData.data.data[0]._id }, data: { tokens: updatedTokens } });
  //     } catch (err) { }
  //   }
  // }
};
